import type { DataOf } from '@elara/firebolt/shared';

import { collectionPath, defineModelSpec, orderBy, where } from '@elara/firebolt/shared';
import { zFirestampOptional } from '@elara/firebolt/zod-types';

import { ItineraryItemBaseSchema } from './schemas/itinerary-item-schemas.js';
import { id, tripId } from './schemas/zod-types.js';

/**
 * The canonical `ModelSpec` for the itinerary subcollection within a trip.
 * It defines the path (`trips/{tripId}/itinerary/{id}`) and the data shape for an itinerary item document.
 * Itinerary items represent planned activities, bookings, and notes for a specific trip.
 */
export const ItineraryItemModelSpec = defineModelSpec({
  path: collectionPath`trips/${tripId}/itinerary/${id}`,
  shape: {
    ...ItineraryItemBaseSchema.shape,
    createdAt: zFirestampOptional(),
    updatedAt: zFirestampOptional(),
  },
  constraints: [
    where('deleted', '==', false), // Filter out soft-deleted items
    orderBy('startDateTime', 'asc'),
    orderBy('createdAt', 'asc'),
  ],
});

export type ItineraryItemModelSpec = typeof ItineraryItemModelSpec;
export interface ItineraryItem extends DataOf<ItineraryItemModelSpec> {}
